<template>
 <div class="text-center grey lighten-5" style="height:700px">
 <v-toolbar flat color="white">
   <v-btn
    to="/painelclassesExportacao"
      class="mx-2"
      fab
      dark
      large
      color="primary"
    >
      <v-icon dark>
        arrow_back
      </v-icon>
    </v-btn>
        </v-toolbar>

      <div v-role="'est'" class="text-center">

    <h2 style="text-align:Center;">Etapas de exportação </h2><br>

  <v-card
    class="mx-auto"
    max-width="700"
    tile
  >
           <!--********************************************************** Verificação de Internet*********************************************************-->

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#0080ff;padding:30px">
          <strong>Verificar o acesso a internet </strong>
          <!-- Ícones para verificação da conexão a internet -->
            <v-icon
                  v-if="isInternet"
                  color="#00ff40"
                  style="padding-left:350px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="!isInternet"
                  color="#ff4000"
                  style="padding-left:350px"
                  large
                >
                 error_outline
                </v-icon>
                <!--Fim Ícones para verificação da conexão a internet -->
          </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
          <!--**********************************************************Fim Verificação de Internet*********************************************************-->
    <!--********************************************************** Carregamento de cadastro*********************************************************-->
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#808080;padding:30px">
          <strong> Carregamento de estudantes cadastrados </strong>
          <!-- Ícones e progress circular para verificação do carregamento dos Dados-->
          <!--isDadosCarregados === 0 (Carregando), isDadosCarregados===1 (Carregamento feito com sucesso), isDadosCarregados === 2 (Erro ao carregar) -->
          <v-progress-circular
          v-if="isDadosCarregados===0"
      indeterminate
      color="primary"
      :size="60"
      x-large
    ></v-progress-circular>
          <v-icon
                  v-if="isDadosCarregados===1"
                  color="#00ff40"
                  style="padding-left:240px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="isDadosCarregados===2"
                  color="#ff4000"
                  style="padding-left:240px"
                  large
                >
                 error_outline
                </v-icon>
                <!--Fim Ícones e progress circular para verificação do carregamento dos Dados-->
                <div v-if="quantidadeCadastroPessoas > 0">{{this.quantidadeCadastroPessoas}} registro(s) encontrado(s)</div>
                <div v-if="isDadosCarregados === 3">Nenhum registro encontrado</div>
                <div v-if="isDadosCarregados === 2">{{menssagem}}</div>
          </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <!--**********************************************************Fim Carregamento de cadastro*********************************************************-->
  <!--********************************************************** Carregamento de turmas*********************************************************-->
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#80c963;padding:30px">
          <strong> Carregamento de turmas </strong>
          <!-- Ícones e progress circular para verificação do carregamento dos Dados-->
          <!--isDadosCarregados === 0 (Carregando), isDadosCarregados===1 (Carregamento feito com sucesso), isDadosCarregados === 2 (Erro ao carregar) -->
          <v-progress-circular
          v-if="isturmasCarregados===0"
      indeterminate
      color="primary"
      :size="60"
      x-large
    ></v-progress-circular>
          <v-icon
                  v-if="isturmasCarregados===1"
                  color="#00ff40"
                  style="padding-left:370px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="isturmasCarregados===2"
                  color="#ff4000"
                  style="padding-left:370px"
                  large
                >
                 error_outline
                </v-icon>
                <!--Fim Ícones e progress circular para verificação do carregamento dos Dados-->
                <div v-if="quantidadeTurmas > 0">{{this.quantidadeTurmas}} registro(s) encontrado(s)</div>
                <div v-if="isturmasCarregados === 3">Nenhum registro encontrado</div>
                <div v-if="isturmasCarregados === 2 && isDadosCarregados !== 2">{{menssagem}}</div>
          </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <!--**********************************************************Fim Carregamento de turmas*********************************************************-->
 <!--********************************************************** Carregamento de estudantes inscritos na turma*********************************************************-->
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#d285e8;padding:30px">
          <strong> Carregamento de estudantes inscritos na turma </strong>
          <!-- Ícones e progress circular para verificação do carregamento dos Dados-->
          <!--isDadosCarregados === 0 (Carregando), isDadosCarregados===1 (Carregamento feito com sucesso), isDadosCarregados === 2 (Erro ao carregar) -->
          <v-progress-circular
          v-if="isestudantesinscritosNaTurmaCarregados===0"
      indeterminate
      color="primary"
      :size="60"
      x-large
    ></v-progress-circular>
          <v-icon
                  v-if="isestudantesinscritosNaTurmaCarregados===1"
                  color="#00ff40"
                  style="padding-left:200px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="isestudantesinscritosNaTurmaCarregados===2"
                  color="#ff4000"
                  style="padding-left:200px"
                  large
                >
                 error_outline
                </v-icon>
                <!--Fim Ícones e progress circular para verificação do carregamento dos Dados-->
                <div v-if="quantidadeestudantesInscritos > 0">{{this.quantidadeestudantesInscritos}} registro(s) encontrado(s)</div>
                <div v-if="isestudantesinscritosNaTurmaCarregados === 3">Nenhum registro encontrado</div>
                <div v-if="isestudantesinscritosNaTurmaCarregados === 2 && isturmasCarregados !== 2 && isDadosCarregados !== 2">{{menssagem}}</div>
          </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <!--**********************************************************Fim Carregamento de estudantes inscritos na turma*********************************************************-->

  <!--********************************************************** Carregamento de Notas*********************************************************-->
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#8cb2d2;padding:30px">
          <strong> Carregamento de Notas </strong>
          <!-- Ícones e progress circular para verificação do carregamento dos Dados-->
          <!--isNotasCarregadas === 0 (Carregando), isNotasCarregadas===1 (Carregamento feito com sucesso), isNotasCarregadas === 2 (Erro ao carregar) -->
          <v-progress-circular
          v-if="isNotasCarregadas===0"
      indeterminate
      color="primary"
      :size="60"
      x-large
    ></v-progress-circular>
          <v-icon
                  v-if="isNotasCarregadas===1"
                  color="#00ff40"
                  style="padding-left:380px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="isNotasCarregadas===2"
                  color="#ff4000"
                  style="padding-left:380px"
                  large
                >
                 error_outline
                </v-icon>
                <!--Fim Ícones e progress circular para verificação do carregamento dos Dados-->
                <div v-if="quantidadeNotas > 0">{{this.quantidadeNotas}} registro(s) encontrado(s)</div>
                <div v-if="isNotasCarregadas === 3">Nenhum registro encontrado</div>
                 <div v-if="isNotasCarregadas === 2 && isestudantesinscritosNaTurmaCarregados !== 2 && isturmasCarregados !== 2 && isDadosCarregados !== 2">{{menssagem}}</div>

          </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <!--**********************************************************Fim Carregamento de Notas*********************************************************-->

 <!--**********************************************************Exportação*********************************************************-->
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title style="text-align:left;background:#ff8000;padding:30px">
           <strong>Actualização da data de exportação  </strong>
             <!-- Ícones e progress circular para verificação da execução da Exportação-->
          <!--isDadosCarregados === 0 (Exportando), isDadosCarregados===1 (Exportação feita com sucesso), isDadosCarregados === 2 (Erro ao Exportar) -->
            <v-progress-circular
          v-if="isUpdateDataControlEvent===0"
      indeterminate
      color="primary"
       :size="60"
      x-large
    ></v-progress-circular>
          <v-icon
                  v-if="isUpdateDataControlEvent===1"
                  color="#00ff40"
                  style="padding-left:290px"
                  large
                >
                 done_outline
                </v-icon>
                <v-icon
                  v-if="isUpdateDataControlEvent===2"
                  color="#ff4000"
                  style="padding-left:290px"
                  large
                >
                 error_outline
                </v-icon>
                 <!--Fim Ícones e progress circular para verificação da execução da Exportação-->
 <div v-if="isUpdateDataControlEvent=== 2 && isNotasCarregadas !== 2 && isestudantesinscritosNaTurmaCarregados !== 2 && isturmasCarregados !== 2 && isDadosCarregados !== 2">{{menssagem}}</div>

           </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <!--**********************************************************Fim Exportação*********************************************************-->
  </v-card>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    url: 'http://relatorios.softlineangola.com/exportToCSV', //  http://relatorios.softlineangola.com
    idEventControl: 3,
    eventControl: [{ id: 0, UltimaDateEvent: '', eventName: '' }], // Array do eventControl
    updateEventControl: [], // Obter o resultado da actualização do eventControl
    headerInscricaoNATurmaCSV: [],
    headerTurmaCSV: [],
    headCSVNotas: [],
    headerPessoaCSV: [],
    instituicaodescricao: ls.get('instituicaodescricao'),
    quantidadeCadastroPessoas: 0, // Quantidade de estudantes a exportar
    quantidadeTurmas: 0,
    quantidadeestudantesInscritos: 0,
    isInternet: false, // Controlador da etapa Verificação de Internet
    isDadosCarregados: 4, // Controlador da etapa carregar Dados
    isestudantesinscritosNaTurmaCarregados: 4, // Controlador da etapa carregar estudantes inscritos na Turma
    isturmasCarregados: 4, // Controlador da etapa carregar turmas
    isUpdateDataControlEvent: 3, // Controlador da etapa Exportação
    estudantes: [], // Array dos estudantes a exportar
    estudantesInscricaoNaTurma: [],
    turmas: [],
    isNotasCarregadas: 4,
    quantidadeNotas: 0,
    notas: [],
    menssagem: ''
  }),
  created () {
    this.verificarInternet()
    this.headerPessoaCSVDefault()
    this.headerTurmaCSVDefault()
    this.headerInscricaoNATurmaCSVDefault()
    this.headerCSVNotasDefault()
    this.isDadosCarregados = 4
    this.isUpdateDataControlEvent = 3
  },
  methods: {
    verificarInternet () {
      if (navigator.onLine) {
        this.isInternet = true
        this.takeEventControl(this.idEventControl)
      } else {
        this.isInternet = false
        this.isDadosCarregados = 2
        this.isNotasCarregadas = 2
        this.isestudantesinscritosNaTurmaCarregados = 2
        this.isturmasCarregados = 2
        this.isUpdateDataControlEvent = 2
      }
    },
    /** Obter apenas a linha de registo do idEvent (3-Exportação de dados e notas)providenciado */
    async takeEventControl (idEvent) {
      try {
        this.eventControl = await axios
          .get('/takeEventControlSlave/' + idEvent)
          .then(res => res.data)
        this.pessoasCadastradas(this.eventControl[0].UltimaDateEvent)
      } catch (error) {
        this.isDadosCarregados = 2
      }
    },
    /** O método pessoasCadastradas() carrega os dados dos estudantes a serem exportados
 Nesse método obtem-se os seguintes resultados
     * 0-Carregando
     *  1-Dados carregados
     * 2-Erro
     * 3-Nenhum registro novo
     * 4- Aguardar a resposta de sucesso da função takeEventControl() (default) */
    async pessoasCadastradas (UltimaDateEvent) {
      this.isDadosCarregados = 0
      let sucessExport = 0
      if (!navigator.onLine) {
        this.isInternet = false
        this.isDadosCarregados = 2
      } else {
        try {
          this.estudantes = await axios
            .get('/pessoasOnSlaveApp/' + UltimaDateEvent)
            .then(res => res.data)
          /** Verificar a existência de novos registros */
          if (this.estudantes.length === 0) {
            this.isDadosCarregados = 3
            this.turmas_(this.eventControl[0].UltimaDateEvent)
          } else
          if (this.estudantes.length > 0) {
            this.quantidadeCadastroPessoas = this.estudantes.length

            try {
              await axios({
                method: 'post',
                url: this.url, //  http://relatorios.softlineangola.com
                data: {
                  data: this.estudantes,
                  headers: this.headerPessoaCSV,
                  filename: ('Documents/chegados/pessoa/PessoasCadastradas_' + ls.get('instituicaodescricao') + '_' + this.eventControl[0].data_)
                }
              }).then(function (response, error) {
                if (!error) {
                  sucessExport = 1
                } else {
                  this.isDadosCarregados = 2
                  this.verificarEstado()
                  this.menssagem = 'Erro ao exportar'
                }
              })
              if (sucessExport === 1) {
                this.isDadosCarregados = 1
                this.turmas_(UltimaDateEvent)
              }
            } catch (error) {
              this.isDadosCarregados = 2
              this.verificarEstado()
              this.menssagem = 'Erro ao exportar'
            }
          }
        } catch (error) {
        /** Erro ao carregar dados no Banco de dados */
          this.isDadosCarregados = 2
          this.verificarEstado()
          this.menssagem = error
        }
      }
    },

    /** O método turmas_() carrega os dados dos estudantes a serem exportados
 Nesse método obtem-se os seguintes resultados
     * 0-Carregando
     *  1-Dados carregados
     * 2-Erro
     * 3-Nenhum registro novo
     * 4- Aguardar a conclusão da primeira etapa (default) */
    async turmas_ (UltimaDateEvent) {
      this.isturmasCarregados = 0
      let sucessExport = 0
      if (!navigator.onLine) {
        this.isInternet = false
        this.isturmasCarregados = 2
      } else {
        try {
          this.turmas = await axios
            .get('/turmasOnSlaveApp/' + UltimaDateEvent)
            .then(res => res.data)
          /** Verificar a existência de novos registros */
          if (this.turmas.length === 0) {
            this.isturmasCarregados = 3
            this.inscricaoNaTurma(this.eventControl[0].UltimaDateEvent)
          }
          if (this.turmas.length > 0) {
            this.quantidadeTurmas = this.turmas.length
            try {
              await axios({
                method: 'post',
                url: this.url, //  http://relatorios.softlineangola.com
                data: {
                  data: this.turmas,
                  headers: this.headerTurmaCSV,
                  filename: ('Documents/chegados/pessoa/Turmas_' + ls.get('instituicaodescricao') + '_' + this.eventControl[0].data_)
                }
              }).then(function (response, error) {
                if (!error) {
                  sucessExport = 1
                } else {
                  this.isturmasCarregados = 2
                  this.verificarEstado()
                  this.menssagem = 'Erro ao exportar'
                }
              })
              if (sucessExport === 1) {
                this.isturmasCarregados = 1
                this.inscricaoNaTurma(UltimaDateEvent)
              }
            } catch (error) {
              this.isturmasCarregados = 2
              this.verificarEstado()
              this.menssagem = 'Erro ao exportar'
            }
          }
        } catch (error) {
          this.isturmasCarregados = 2
          this.verificarEstado()
          this.menssagem = error
        }
      }
    },

    /** O método inscricaoNaTurma() carrega os dados dos estudantes a serem exportados
 Nesse método obtem-se os seguintes resultados
     * 0-Carregando
     *  1-Dados carregados
     * 2-Erro
     * 3-Nenhum registro novo
     * 4- Aguardar a conclusão da primeira etapa (default) */
    async inscricaoNaTurma (UltimaDateEvent) {
      this.isestudantesinscritosNaTurmaCarregados = 0
      let sucessExport = 0
      if (!navigator.onLine) {
        this.isInternet = false
        this.isestudantesinscritosNaTurmaCarregados = 2
      } else {
        try {
          this.estudantesInscricaoNaTurma = await axios
            .get('/inscricaoNaTurmaOnSlaveApp/' + UltimaDateEvent)
            .then(res => res.data)
          /** Verificar a existência de novos registros */
          if (this.estudantesInscricaoNaTurma.length === 0) {
            this.isestudantesinscritosNaTurmaCarregados = 3
            this.carregarNotas(UltimaDateEvent)
          } else
          if (this.estudantesInscricaoNaTurma.length > 0) {
            this.quantidadeestudantesInscritos = this.estudantesInscricaoNaTurma.length
            try {
              await axios({
                method: 'post',
                url: this.url, //  http://relatorios.softlineangola.com
                data: {
                  data: this.estudantesInscricaoNaTurma,
                  headers: this.headerInscricaoNATurmaCSV,
                  filename: ('Documents/chegados/inscricao_na_turma/InscricaoNaTurma_' + ls.get('instituicaodescricao') + '_' + this.eventControl[0].data_)
                }
              }).then(function (response, error) {
                if (!error) {
                  sucessExport = 1
                } else {
                  this.isestudantesinscritosNaTurmaCarregados = 2
                  this.verificarEstado()
                  this.menssagem = 'Erro ao exportar'
                }
              })
              if (sucessExport === 1) {
                this.isestudantesinscritosNaTurmaCarregados = 1
                this.carregarNotas(UltimaDateEvent)
              }
            } catch (error) {
              this.isestudantesinscritosNaTurmaCarregados = 2
              this.verificarEstado()
              this.menssagem = 'Erro ao exportar'
            }
          }
        } catch (error) {
          this.isestudantesinscritosNaTurmaCarregados = 2
          this.verificarEstado()
          this.menssagem = error
        }
      }
    },

    /** O método carregarNotas() carrega as notas dos estudantes a serem exportados
 Nesse método obtem-se os seguintes resultados
     * 0-Carregando
     *  1-Notas carregadas
     * 2-Erro
     * 3-Nenhum registro novo
     * 4- Aguardar a conclusão da primeira etapa (default) */
    async carregarNotas (UltimaDateEvent) {
      this.isNotasCarregadas = 0
      let sucessExport = 0
      if (!navigator.onLine) {
        this.isInternet = false
        this.isNotasCarregadas = 2
      } else {
        try {
          this.notas = await axios
            .get('/notasEstudantesSlave/' + UltimaDateEvent)
            .then(res => res.data)
          /** Verificar a existência de novos registros */
          if (this.notas.length === 0) {
            this.isNotasCarregadas = 3
          }
          if (this.notas.length > 0) {
            this.quantidadeNotas = this.notas.length
            try {
              await axios({
                method: 'post',
                url: this.url,
                data: {
                  data: this.notas,
                  headers: this.headCSVNotas,
                  filename: ('Documents/chegados/notas/Notas' + ls.get('instituicaodescricao') + '_' + this.eventControl[0].data_)
                }
              }).then(function (response, error) {
                if (!error) {
                  sucessExport = 1
                } else {
                  this.isNotasCarregadas = 2
                  this.verificarEstado()
                  this.menssagem = 'Erro ao exportar'
                }
              })
              if (sucessExport === 1) {
                this.isNotasCarregadas = 1
                this.updateEventControl_(this.idEventControl)
              }
            } catch (error) {
              this.isNotasCarregadas = 2
              this.verificarEstado()
              this.menssagem = 'Erro ao exportar'
            }
          }
        } catch (error) {
          this.isNotasCarregadas = 2
          this.verificarEstado()
          this.menssagem = error
        }
      }
    },

    /** Actualizar o campo UltimaDateEvent da tabela eventControl */
    async updateEventControl_ (idEvent) {
      this.isUpdateDataControlEvent = 0
      try {
        this.updateEventControl = await axios
          .get('/updateEventControlSlave/' + idEvent)
          .then(res => res.data)
        this.isUpdateDataControlEvent = 1
      } catch (error) {
        this.isUpdateDataControlEvent = 2
        this.menssagem = error
      }
    },
    verificarEstado () {
      if (this.isInternet === false) {
        this.menssagem = 'Sem acesso a Internet'
      } else
      if (this.isDadosCarregados === 2) {
        this.isNotasCarregadas = 2
        this.isestudantesinscritosNaTurmaCarregados = 2
        this.isturmasCarregados = 2
        this.isUpdateDataControlEvent = 2
      } else
      if (this.isturmasCarregados === 2) {
        this.isNotasCarregadas = 2
        this.isestudantesinscritosNaTurmaCarregados = 2
        this.isUpdateDataControlEvent = 2
      } else
      if (this.isestudantesinscritosNaTurmaCarregados === 2) {
        this.isestudantesinscritosNaTurmaCarregados = 2
        this.isNotasCarregadas = 2
        this.isUpdateDataControlEvent = 2
      }
      if (this.isNotasCarregadas === 2) {
        this.isUpdateDataControlEvent = 2
      }
    },
    /** Preenchendo o Header do Excel */
    headerPessoaCSVDefault () {
      this.headerPessoaCSV = [
        { 'id': 'idPEssoa', 'title': 'idPEssoa' },
        { 'id': 'idMunicipio', 'title': 'idMunicipio' },
        { 'id': 'idPerfil', 'title': 'idPerfil' },
        { 'id': 'nome', 'title': 'nome' },
        { 'id': 'morada', 'title': 'morada' },
        { 'id': 'telefone', 'title': 'telefone' },
        { 'id': 'autor', 'title': 'autor' },
        { 'id': 'datanascimento', 'title': 'datanascimento' },
        { 'id': 'data_', 'title': 'data_' },
        { 'id': 'status_2', 'title': 'status_2' },
        { 'id': 'email', 'title': 'email' },
        { 'id': 'sexo', 'title': 'sexo' },
        { 'id': 'nomedopai', 'title': 'nomedopai' },
        { 'id': 'nomedamae', 'title': 'nomedamae' },
        { 'id': 'dataemissaobi', 'title': 'dataemissaobi' },
        { 'id': 'bi', 'title': 'bi' },
        { 'id': 'ResidenteEm', 'title': 'ResidenteEm' },
        { 'id': 'instituicao', 'title': 'instituicao' },
        { 'id': 'instituicaodescricao', 'title': 'instituicaodescricao' },
        { 'id': 'idMatricula', 'title': 'idMatricula' },
        { 'id': 'idCurso', 'title': 'idCurso' },
        { 'id': 'anoLectivo', 'title': 'anoLectivo' }

      ]
    },
    headerTurmaCSVDefault () {
      this.headerTurmaCSV = [
        { 'id': 'idTurma', 'title': 'idTurma' },
        { 'id': 'idCurso', 'title': 'idCurso' },
        { 'id': 'idAno_Academico', 'title': 'idAno_Academico' },
        { 'id': 'data_2T', 'title': 'data_2' },
        { 'id': 'descricao', 'title': 'descricao' },
        { 'id': 'autorT', 'title': 'autor' },
        { 'id': 'anoLectivo', 'title': 'anoLectivo' },
        { 'id': 'periodo', 'title': 'periodo' },
        { 'id': 'idinstituicao', 'title': 'idinstituicao' },
        { 'id': 'idAnoLectivo', 'title': 'idAnoLectivo' },
        { 'id': 'status_2T', 'title': 'status_2' }

      ]
    },
    headerInscricaoNATurmaCSVDefault () {
      this.headerInscricaoNATurmaCSV = [
        { 'id': 'idInscricao_na_turma', 'title': 'idInscricao_na_turma' },
        { 'id': 'idTurma', 'title': 'idTurma' },
        { 'id': 'idAnoLectivo', 'title': 'idAnoLectivo' },
        { 'id': 'idMAtricula', 'title': 'idMAtricula' },
        { 'id': 'data_2Inscricao', 'title': 'data_2' },
        { 'id': 'autorInscricao', 'title': 'autor' },
        { 'id': 'status_2Inscricao', 'title': 'status_2' },
        { 'id': 'anoLectivo', 'title': 'anoLectivo' },
        { 'id': 'resultado', 'title': 'resultado' },
        { 'id': 'auto_data', 'title': 'auto_data' },
        { 'id': 'unique_title', 'title': 'unique_title' },
        { 'id': 'fkPessoa', 'title': 'fkPessoa' },
        { 'id': 'fkTurma', 'title': 'fkTurma' },
        { 'id': 'idano_academico', 'title': 'idano_academico' },
        { 'id': 'idinstituicao', 'title': 'idinstituicao' },
        { 'id': 'flag_transferencia', 'title': 'flag_transferencia' }

      ]
    },
    headerCSVNotasDefault () {
      this.headCSVNotas = [

        { 'id': 'idpauta', 'title': 'idpauta' },
        { 'id': 'iddisciplina', 'title': 'iddisciplina' },
        { 'id': 'idInscricao_na_turma', 'title': 'idInscricao_na_turma' },
        { 'id': 'idperfil', 'title': 'idperfil' },
        { 'id': 'nota', 'title': 'nota' },
        { 'id': 'autor', 'title': 'autor' },
        { 'id': 'data_2', 'title': 'data_2' },
        { 'id': 'notaMac', 'title': 'notaMac' },
        { 'id': 'nota2', 'title': 'nota2' },
        { 'id': 'MD', 'title': 'MD' },
        { 'id': 'estudante_bi', 'title': 'estudante_bi' },
        { 'id': 'anoLectivo', 'title': 'anoLectivo' },
        { 'id': 'epoca', 'title': 'epoca' },
        { 'id': 'idTurma', 'title': 'idTurma' },
        { 'id': 'p2_nota', 'title': 'p2_nota' },
        { 'id': 'p2_data2', 'title': 'p2_data2' },
        { 'id': 'p2_autor', 'title': 'p2_autor' },
        { 'id': 'p2_notaMac', 'title': 'p2_notaMac' },
        { 'id': 'p2_nota2', 'title': 'p2_nota2' },
        { 'id': 'p2_MD', 'title': 'p2_MD' },
        { 'id': 'idcontrolopauta', 'title': 'idcontrolopauta' },
        { 'id': 'p3_nota', 'title': 'p3_nota' },
        { 'id': 'p3_autor', 'title': 'p3_autor' },
        { 'id': 'p3_data2', 'title': 'p3_data2' },
        { 'id': 'p3_notaMac', 'title': 'p3_notaMac' },
        { 'id': 'pg', 'title': 'pg' },
        { 'id': 'p3_MD', 'title': 'p3_MD' },
        { 'id': 'CA', 'title': 'CA' },
        { 'id': 'MF', 'title': 'MF' },
        { 'id': 'CA_A', 'title': 'CA_A' },
        { 'id': 'mfd', 'title': 'mfd' },
        { 'id': 'disciplina_bienal', 'title': 'disciplina_bienal' },
        { 'id': 'ano_academico', 'title': 'ano_academico' },
        { 'id': 'matricula', 'title': 'matricula' },
        { 'id': 'desc_disc', 'title': 'desc_disc' },
        { 'id': 'cadeiraStatus', 'title': 'cadeiraStatus' },
        { 'id': 'cadeiraAnoqueFez', 'title': 'cadeiraAnoqueFez' },
        { 'id': 'cadeiraNota', 'title': 'cadeiraNota' },
        { 'id': 'recurso', 'title': 'recurso' },
        { 'id': 'examedata_2', 'title': 'examedata_2' },
        { 'id': 'pgdata_2', 'title': 'pgdata_2' },
        { 'id': 'idinstituicao', 'title': 'idinstituicao' },
        { 'id': 'UltimaDateEvent', 'title': 'UltimaDateEvent' },
        { 'id': 'notas_transportadas', 'title': 'notas_transportadas' },
        { 'id': 'fkInscricao_na_turma', 'title': 'fkInscricao_na_turma' },
        { 'id': 'fkTurma', 'title': 'fkTurma' }
      ]
    }
  }
}
</script>
